import { CommonService } from './../../core/services/common/common.service';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuoteStatusConstants } from './../constants/constant';
import { MatDialog } from '@angular/material/dialog';
import { Email } from './../../core/model/delivery.model';
import deepEqual from 'deep-equal';
@Injectable()
export class HelperService {
  constructor(
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public _commonService: CommonService
  ) {}

  async delay(ms: number) {
    await new Promise<void>((resolve) => setTimeout(() => resolve(), ms)).then(
      () => {}
    );
  }

  scrollToPosition(element) {
    let newScrollTop =
      window.pageYOffset > 500
        ? element.getBoundingClientRect().top / 2
        : window.pageYOffset;
    window.scroll({
      top: newScrollTop > 0 ? newScrollTop : 0,
      behavior: 'auto',
    });
  }

  removeSpecialCharacters(str: string) {
    return str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').replace(/\s/g, '');
  }

  arrayValueExists(array: any, column: any, value: any) {
    return array.some(function (el: any) {
      return el[column] === value;
    });
  }

  joinEmailsWithSeparator(emails: Email[], separator: string) {
    return emails
      .map((item: any) => {
        return item.name;
      })
      .join(separator);
  }

  splitEmailsWithSeparator(
    email: string,
    separator1: string,
    separator2: string
  ) {
    return email.split(separator1).map((e) => e.split(separator2));
  }

  convertDateToFormat(objDate: any, format: any) {
    if (objDate) {
      let dt: any;
      try {
        //dt = new Date(objDate.replace(/[^ -~]/g, ''))
        let dateParsed = Date.parse(objDate);
        dt = this.datePipe.transform(dateParsed, format);
      } catch {
        dt = null;
      }
      return dt;
    }
    return null;
  }

  getDate(objDate: any) {
    if (objDate) {
      let dt: any;
      try {
        //dt = new Date(objDate.replace(/[^ -~]/g, ''))
        let dateParsed = Date.parse(objDate);
        dt = new Date(dateParsed);
      } catch {
        dt = new Date();
      }
      return dt;
    }
    return null;
  }

  isEnrollmentDateValid(enrollmentDate) {
    return this._commonService.enrollmentDates.filter(
      (d) => d === enrollmentDate
    );
  }

  isEmployeeEnrollmentDateValid(enrollmentDate: any) {
    let isEnrollmentDateValid = this.isEnrollmentDateValid(enrollmentDate);
    if (!isEnrollmentDateValid || isEnrollmentDateValid.length === 0) {
      return false;
    }
    return true;
  }
  isEmployeeFormValid(employeeForm: any) {
    let isEnrollmentDateValid = this.isEnrollmentDateValid(
      employeeForm.EnrollmentDate
    );
    if (!isEnrollmentDateValid || isEnrollmentDateValid.length === 0) {
      return false;
    }
    if (
      !employeeForm.ZipCode ||
      !employeeForm.CountyCode ||
      !employeeForm.StateId ||
      !employeeForm.FirstName ||
      !employeeForm.LastName ||
      !employeeForm.GenderTypeId ||
      !employeeForm.DOB ||
      employeeForm.DOB != this.formatDate(new Date(employeeForm.DOB))
    ) {
      return false;
    }
    return true;
  }

  getEnrollmentDates() {
    this._commonService.enrollmentDates = [];
    let effectiveDate =
      this._commonService.groupDetailsData.EffectiveDate ||
      new Date().toString();
    let enrollDate = this.getDate(effectiveDate);
    if (enrollDate) {
      //The months available will be 11 months in the future from the group “Effective Date”.
      for (let index = 0; index < 12; index++) {
        let d = new Date(
          enrollDate.getFullYear(),
          enrollDate.getMonth() + index,
          1
        )
          .toLocaleString()
          .split(/[ ,]/)[0];
        if (d) {
          this._commonService.enrollmentDates.push(d.replace(/[^ -~]/g, ''));
        }
      }
    }
    this._commonService.enrollmentDatesSubject.next(
      this._commonService.enrollmentDates
    );
    return this._commonService.enrollmentDates;
  }

  calculateAgeFromEffectiveDate(dateObj: any, effectiveDate: any) {
    let birthDate = new Date(dateObj);
    let quoteEffectiveDate = new Date(effectiveDate);

    let age = quoteEffectiveDate.getFullYear() - birthDate.getFullYear();

    if (
      quoteEffectiveDate.getMonth() < birthDate.getMonth() ||
      (quoteEffectiveDate.getMonth() == birthDate.getMonth() &&
        quoteEffectiveDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    if (age < 0) {
      return 0;
    }
    return age;
  }

  removeSpecialCharsFromDate(date: Date): string {
    return date
      .toLocaleString()
      .replace(
        /[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g,
        ''
      );
  }

  calculateAge(calculateDate: any, DOB: any) {
    let calculateDateAge =
      (calculateDate.getFullYear() * 100 + calculateDate.getMonth()) * 100 +
      calculateDate.getDate();
    let dobCalculateAge =
      (DOB.getFullYear() * 100 + DOB.getMonth()) * 100 + DOB.getDate();
    let calculatedAge = (
      (calculateDateAge - dobCalculateAge) /
      10000
    ).toString();
    return parseInt(calculatedAge);
  }

  setNewHiresIndex(newHires: any) {
    newHires.forEach((x: any, index: any) => {
      x.uniqueEmpId = index;
    });
  }

  setNewHiresUniqueId(newHires: any) {
    let Id = 0;
    if (newHires.length > 0) {
      newHires.forEach((x: any, index: any) => {
        Id = x.Id = Id + 1;
        x.Dependents.forEach((y: any, dependentIndex: any) => {
          Id = y.Id = Id + 1;
        });
      });
    }
  }

  filterGroups(groupDetail: any) {
    if (
      groupDetail.QuoteId != 0 &&
      (groupDetail.QuoteStatus == QuoteStatusConstants.Final ||
        groupDetail.QuoteStatus == QuoteStatusConstants.Sold ||
        groupDetail.QuoteStatus == QuoteStatusConstants.Completed)
    )
      return true;
    else return false;
  }

  getCurrentGroupId() {
    var censusGroupId = 0;
    if (localStorage) {
      var groupId = localStorage.getItem('group_id');
      if (groupId != null && groupId != undefined && groupId != '') {
        censusGroupId = Number(groupId);
      }
    }
    return censusGroupId;
  }

  getUniquePlansCount(carrierData: any) {
    let distinctPlans = [];
    carrierData.Plans.forEach((plan: any, index: any) => {
      let planIndex = distinctPlans.indexOf(plan.PlanId);
      if (planIndex == -1) {
        distinctPlans.push(plan.PlanId);
      }
    });
    carrierData.OOSPlans.forEach((element: any, index: any) => {
      element.Plans.forEach((plan: any) => {
        let planIndex = distinctPlans.indexOf(plan.PlanId);
        if (planIndex == -1) {
          distinctPlans.push(plan.PlanId);
        }
      });
    });
    return distinctPlans;
  }

  // Get value from QueryString
  getValueFromRoute(activatedRoute: ActivatedRoute, param: string): string {
    let value: string;
    activatedRoute.paramMap.subscribe((params) => {
      value = params.get(param);
    });
    return value;
  }

  removeDuplicatePlans(planList: any) {
    var distinctPlans = [];
    var allPlanIds = [];
    for (var i = 0; i < planList.length; i++) {
      if (allPlanIds.indexOf(planList[i].PlanId) === -1) {
        distinctPlans.push(planList[i]);
        allPlanIds.push(planList[i].PlanId);
      }
    }
    return distinctPlans;
  }

  validateDeliveryMail(value: any) {
    if (value || value.length > 0) {
      let isValid = true;
      var regexp = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,19}$/
      );
      if (value != undefined && value != '') {
        let _emailList = value.split(/[\;,]+/);
        if (_emailList.length > 0) {
          _emailList.forEach((element: any) => {
            if (!regexp.test(element.trim())) {
              isValid = false;
            }
          });
        }
      }
      return isValid;
    }
    return null;
  }

  getStateId() {
    return localStorage.getItem('broker_state') == null ||
      localStorage.getItem('broker_state') == undefined
      ? 0
      : parseInt(localStorage.getItem('broker_state'));
  }

  getStateIdOnStateCode(stateCode) {
    let stateId = 54;
    switch (stateCode) {
      case 'NV':
        stateId = 40;
        break;
      case 'CA':
        stateId = 54;
        break;
      case 'AZ':
        stateId = 16;
        break;
    }
    return stateId;
  }

  getEnumNameOnValue(enumList, enumValue) {
    for (var enumMember in enumList) {
      if (enumList[enumMember] == enumValue) return enumMember;
    }
    return null;
  }

  isEqual(orgData: any, newData: any) {
    let originalData = JSON.stringify(orgData).replace(/"null"/g, '""');
    let changedData = JSON.stringify(newData).replace(/"null"/g, '""');

    originalData = originalData.replace(/"null"/g, '""');
    changedData = changedData.replace(/"null"/g, '""');

    orgData = JSON.parse(originalData);
    newData = JSON.parse(changedData);

    return deepEqual(orgData, newData);
  }

  // format date as "m/d/yyyy"
  // make sure this format is consistent with the "future" dates from api
  formatDate(date) {
    var d = date.getDate(); // 25
    var m = date.getMonth() + 1; // 9=Oct -- so we add one
    var y = date.getFullYear(); // 2021
    return m + '/' + d + '/' + y;
  }
}
